__turbopack_context__.v({
  "wrapper": "BlocksRenderer-module__o37_gq__wrapper",
});
